module.exports = __webpack_public_path__ + "images/beea2f1efd2280d508222a1490fdcee8-bg.jpg";